import type { IAuthService } from '@src/domain/interfaces/auth/IAuthService';
import type { User } from '@src/domain/entities/auth/user/User';

/**
 * Authentication Service - Application layer
 * Abstract service that defines authentication operations
 * Following Interface Segregation and Dependency Inversion principles
 */
export abstract class AuthService implements IAuthService {
  abstract login(): Promise<void>;
  abstract logout(): Promise<void>;
  abstract isAuthenticated(): boolean;
  abstract getUser(): User | null;
  abstract isLoading(): boolean;
  abstract getAccessToken(): Promise<string | null>;
}
